import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../../constants'
import { fontSize2XSmall } from '../../../constants/principles'
const standardItems = [
  { title: 'Your Offer Confirmation', subtitle: 'on your phone or printed' },
  { title: 'Title, aka "Pink Slip"', subtitle: 'if the vehicle is paid off' },
  { title: 'Payoff or Leasing Info', subtitle: "if the vehicle isn't paid off yet" },
  { title: 'Vehicle Registration' },
  { title: "Driver's License or Govt. ID" },
  { title: 'Proof of Insurance', subtitle: 'if buying another car' },
  { title: 'All Keys, Remotes, and Manuals' },
  { title: 'Maintenance and Repair Records' }
]
const directToKBBv2Items = [
  { title: 'Your Offer Confirmation', subtitle: '(on your phone or printed)' },
  { title: 'Vehicle Title, aka "Pink Slip"', subtitle: '(if the vehicle is paid off)' },
  { title: 'Vehicle Registration' },
  { title: "Valid Driver's License or Govt. ID" },
  { title: 'All Keys, Remotes and Manuals' },
  { title: 'Maintenance & Repair Records' }
]
let personalBelongingsMessage = 'Remember to remove all your personal belongings, and if you’re not buying another car, arrange for a ride home.'

export default ({ dealerIsDirectToKBB, dealerIsDirectToKBBv2 }) => {
  if (dealerIsDirectToKBB || dealerIsDirectToKBBv2) {
    personalBelongingsMessage = 'Remember to remove all personal belongings.'
  }

  let neededItems = dealerIsDirectToKBBv2 ? directToKBBv2Items : standardItems

  return (
    <>
      <NeededItemsDiv>
        <StyledUl>
          {neededItems.map(i => (
            <StyledLi key={i.title}>
              <TextDiv fontWeight="bold">{i.title}</TextDiv>
              {i.subtitle && <TextDiv>{i.subtitle}</TextDiv>}
            </StyledLi>
          ))}
          {dealerIsDirectToKBBv2 && <HiddenLi></HiddenLi>}
        </StyledUl>
      </NeededItemsDiv>
      <RememberDiv>
        <TextDiv2 fontWeight="bold" dealerIsDirectToKBB={dealerIsDirectToKBB || dealerIsDirectToKBBv2}>
          {personalBelongingsMessage}
        </TextDiv2>
      </RememberDiv>
    </>
  )
}

const StyledUl = styled.ul`
  font-size: ${fontSize2XSmall};
  max-width: 550px;
  @media (min-width: ${breakpoints.mid}px) {
    column-count: 2;
  }
  @media print {
    column-count: 2;
  }
  text-align: left;
`
const NeededItemsDiv = styled.div`
  display: flex;
  justify-content: center;
`
const TextDiv = styled.div`
  font-weight: ${p => p.fontWeight};
  font-size: ${p => p.fontSize};
`

const TextDiv2 = styled.div`
  font-weight: ${p => p.fontWeight};
  font-size: ${p => p.fontSize};
  padding-top: ${p => (p.dealerIsDirectToKBB ? '8px' : `0px`)};
`

const RememberDiv = styled.div`
  display: flex;
  justify-content: center;
  font-size: ${fontSize2XSmall};
  padding: 0 16px;
  width: 100%;
  @media (min-width: ${breakpoints.mid}px) {
    column-count: 2;
    max-width: 550px;
  }
`
const StyledLi = styled.li`
  padding-bottom: 8px;
`

const HiddenLi = styled.li`
  list-style: none;
  @media (min-width: ${breakpoints.mid}px) {
    padding-bottom: 42px;
  }
`
